<template>
    <slot v-if="isClient"></slot>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const isClient = ref(false);

onMounted(() => {
    isClient.value = true;
});
</script>
